export const FACTOR_VIEWS = {
  STYLE: "style",
}

export const FACTOR_VIEW_OPTIONS = [{
  id: FACTOR_VIEWS.STYLE,
  primaryText: FACTOR_VIEWS.STYLE,
}]

// [TODO] Already moved to helpers/metrics.js, but need to update a bunch of references
// so I'm also leaving it here for now.
export const METRIC_TYPES = {
  NET_CONTRIBUTION: "netContribution",
  Z_SCORE: "assetZScore",
  CURRENCY_EXPOSURE: "currencyExposure",
  CURRENCY_PERFORMANCE: "currencyPerformance",
  RISK_DECOMPOSITION: "riskDecomposition",
  STANDALONE: "standalone",
}

export const ASSET_TYPES = ["equities", "swaps", "currencies", "fixedIncome", "commodities", "otherAssets", "indexes"]

export const ASSET_TYPES_MAP = {
  EQUITY: "equity",
  SWAP: "swap",
  BASKET: "basket",
  CURRENCY: "currency",
  FIXED_INCOME: "fixedIncome",
  COMMODITY: "commodity",
  OTHER_ASSET: "otherAsset",
  INDEX: "index",
  ETF: "etf",
  PORTFOLIO: "portfolio",
}

export const PERF_COLOR = "#00abe8"

export const DELTA_SYMBOL = "\u0394"
